/**
 * フラグクラス
 */
export class Flag {
    static OFF = "0";
    static ON = "1";
    static OFFtoON = "2";
    static ONtoOFF = "3";
    static INVALID = "-1";

    // インスタンス変数
    code: string;

    constructor(code: string) {
        this.code = code;
    }

    // フラグを日本語で返します
    toString(): string {
        switch(this.code) {
            case Flag.ON :
                return "ON";
            case Flag.OFF :
                return "OFF";
            case Flag.OFFtoON :
                return "OFFtoON";
            case Flag.ONtoOFF :
                return "ONtoOFF";
            default :
                return "INVALID";
        }
    }
    isON(): boolean  {
        return this.code === Flag.ON;
    }
    isOFF(): boolean  {
        return this.code === Flag.OFF;
    }
    isONtoOFF(): boolean  {
        return this.code === Flag.ONtoOFF;
    }
    isOFFtoON(): boolean  {
        return this.code === Flag.OFFtoON;
    }

    // チェックボックスの場合このフラグをチェック扱いにするかどうか
    isCheck(): boolean {
        return this.code === Flag.ON || this.code === Flag.ONtoOFF || this.code === Flag.OFFtoON;
    }
    // このフラグを示したいときの色を返します
    getColor(): string {
        switch(this.code) {
            case Flag.ON :
                return "#A3C1DA";
            case Flag.OFF :
                return "#FF9A9E";
            case Flag.OFFtoON :
                return "#A3C9A8";
            case Flag.ONtoOFF :
                return "#FFB3AB";
            default :
                return "INVALID";
        }
    }
}